import Component from "../component.abstract"
import {AccountDataInterface} from "@models/account-data"

export default class Menu extends Component {
    menu: HTMLElement;
    constructor(
        private props: unknown,
        element:HTMLElement
    ) { 
        super(props, element)
    }

    mounted():void {
       this.menu = this.element.querySelector("nav.menu");
        if(this.menu) {
            //gestion accountdata
            PubSub.subscribe("account-data", (msg:string, data: AccountDataInterface)=> {
                if (data.IsAuthenticated) {
                    this.menu.classList.add("connected")
                } else {
                    this.menu.classList.remove("connected")
                }
            });
        }
    }

}